if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.spinner = this.querySelector('.loading__spinner');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(event) {
        event.preventDefault();

        if (
          !this.submitButton ||
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();
        this.error = false;
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.spinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        config.body = formData;

        try {
          const addUrl =
            window.routes?.cart_add_url ||
            (typeof routes !== 'undefined' ? routes.cart_add_url : null) ||
            '/cart/add.js';

          const response = await fetch(addUrl, config);
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(
              result.description ||
                result.message ||
                'Unable to add this item.'
            );
          }

          await this.refreshCartIcon();

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal && typeof quickAddModal.hide === 'function') {
            quickAddModal.hide(true);
          }

          if (
            typeof publish === 'function' &&
            window.PUB_SUB_EVENTS?.cartUpdate
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: variantId,
              cartData: result,
            });
          }

          document.dispatchEvent(
            new CustomEvent('sc:cart-added', {
              bubbles: true,
              detail: {
                item: result,
                message: 'Item added to cart',
              },
            })
          );
        } catch (error) {
          console.error('Add to cart error:', error);
          this.handleErrorMessage(
            error.message || 'Unable to add this item.'
          );
          this.error = true;
        } finally {
          this.submitButton.classList.remove('loading');
          this.spinner?.classList.add('hidden');

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }
        }
      }

      async refreshCartIcon() {
        try {
          const cartUrl = window.routes?.cart_url || '/cart';
          const response = await fetch(
            `${cartUrl}?section_id=cart-icon-bubble`,
            {
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
              },
            }
          );

          if (!response.ok) return;

          const html = await response.text();
          const parsed = new DOMParser().parseFromString(
            html,
            'text/html'
          );
          const newBubble = parsed.querySelector(
            '#shopify-section-cart-icon-bubble'
          );
          const currentBubble = document.querySelector(
            '#shopify-section-cart-icon-bubble'
          );

          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        } catch (error) {
          console.error('Unable to refresh cart count:', error);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings?.addToCart || 'Add to cart';
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
